import { fetch } from '../request';

export type TParams = {
  id?: number;
  page?: number;
  page_size?: number;
  name__icontains?: number;
  user_count?: number;
  user_count__gt?: number;
};

export interface ProjectType {
  id?: number;
  name?: string;
  character_id?: number;
  template_id?: number;
  secret_id?: string;
  organization_id?: number;
  username?: string;
  user_id?: number;
  project_team_id?: number;
  create_time?: string;
  update_time?: string;
  is_deleted?: boolean;
  user_count?: number;
  project_count?: number;
  resolution?: string;
  last_project_data?: Array<{
    project_id?: number;
    secret_id?: string;
    first_segment_media_url?: string;
  }>;
  project_team_permissions?: Array<{
    user_id?: number;
    permission?: number;
  }>;
  is_default?: boolean;
  description?: string;
}

// 作品-列表
export const getOpusList = (params: TParams) => {
  return fetch('/youyan/project/', {
    method: 'GET',
    params,
  });
};

// 新建作品
export const addOpus = (params: ProjectType) => {
  return fetch('/youyan/project/', {
    method: 'POST',
    body: params,
  });
};

// 修改Opus
export const editOpus = (params: ProjectType) => {
  return fetch('/youyan/project/', {
    method: 'PUT',
    body: params,
  });
};

// 删除项目
export const deleteOpus = (project_team_ids: number[]) => {
  return fetch('/youyan/project/', {
    method: 'DELETE',
    body: {
      project_team_ids,
    },
  });
};

// 复制/通过生成记录另存
export const duplicateOpus = (source_id: number) => {
  return fetch('/youyan/project/duplicate/', {
    method: 'POST',
    body: {
      source_id,
    },
  });
};

// 重置作品相关内容和数据
export const resetOpus = (params: any) => {
  return fetch('/youyan/project/reset_segments/', {
    method: 'POST',
    body: params,
  });
};
